import React from 'react';
import { Button } from '@mui/material';
import { BaseDialog } from './BaseDialog.js';

export function DrazticWebsiteDialog(data) {
    return (
        <BaseDialog
            thumbnail={data.thumbnail}
            title={data.title}
            text={data.text}
            actions={(handleClose) => (
                <Button autoFocus onClick={handleClose} href={data.url} target="_blank" color="secondary">
                    View Website
                </Button>
            )}
        >
            <img src={data.thumbnail} title={data.title} alt={data.text} />
        </BaseDialog>
    );
}
